import { useState, useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../storage/api";
import { cartActions } from "../../storage/cart";
import { modalActions } from "../../storage/modals";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Carousel, Empty, Flex, Image, Result, Skeleton, Spin } from "antd";

const AddToCart = (props) => {
  let id = useSelector((state) => state.modals.data.addToCartId);
  const cart = useSelector((state) => state.cart.goods);
  const [product, setProduct] = useState({});
  const [addition, setAddition] = useState("");
  const [price, setPrice] = useState(0);
  const [done, setDone] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const getProduct = async () => {
      try {
        setIsFetching(true);
        const response = await fetch(`${api.apiPath}&path=product&id=${id}`);

        if (!response.ok) {
          console.log("Error while loading product's data");
          return;
        }

        const payload = await response.json();

        setProduct(payload);
        setAddition("");
        setDone(false);
        setPrice(payload.price);
      } finally {
        setIsFetching(false);
      }
    };

    getProduct();
  }, [id]);

  const setAdditionHandler = (event) => {
    let value = event.target.value.trim();
    const price = parseFloat(product.price);

    if (product.dynamic === "1") {
      value = parseFloat(value);
      const min = parseFloat(product.min);
      const max = parseFloat(product.max);
      const step = parseFloat(product.step);

      if (isNaN(value)) {
        setAddition("");
        setPrice(price);
      } else if (value > max) {
        setAddition(max);
        setPrice((max / step) * price);
      } else if (value < min) {
        setAddition(min);
        setPrice((min / step) * price);
      } else {
        setAddition(value);
        setPrice((value / step) * price);
      }
    } else {
      setAddition(value);
      setPrice(price);
    }
  };

  const addToCart = () => {
    if (product.addition === "1" && addition === "") {
      alert(`Поле "${product.placeholder_addition}" обязательно к заполнению!`);
      return;
    }

    let period = product.period !== "" ? product.period : false;

    if (!period && addition !== "") {
      period = `${product.placeholder_addition}: ${addition}`;
    }

    const productData = {
      addition: addition !== "" ? addition : false,
      category: product.category,
      icon: product.icon,
      id: product.id,
      name: product.name,
      period,
      price: product.price,
      total: price,
    };

    const search = cart.findIndex((item) => {
      return item.id === id;
    });

    if (search >= 0) {
      window.alert("Этот товар уже добавлен в корзину!");
    } else {
      dispatch(cartActions.addToCart(productData));
      setDone(true);
    }
  };

  const openCart = () => {
    dispatch(modalActions.hideAllModals());
    dispatch(modalActions.showCartModal());
  };

  return (
    <div className={done ? "modal-window modal-window_card-added" : "modal-window modal-window_card-add"}>
      <div className="modal-controls-wrapper">
        <h5 className="modal-title">{done ? "Товар добавлен в корзину!" : "Добавить в корзину"}</h5>
        <button type="button" className="modal-close" onClick={props.closeHandler}></button>
      </div>
      <div className={Object.keys(product).length === 0 ? "modal-gray loading noafterblock" : "modal-gray"}>
        <div className="card-add-item">
          <div className="card-add-item__photo">
            {product.icon != null && <LazyLoadImage src={product.icon !== "" ? api.apiUrl + product.icon : "/assets/images/dummy_product.png"} alt={product.name} />}
          </div>
          <div className="card-add-item__data">
            <div className="card-add-meta-row">
              <div className="card-add-title-row">
                <h5 className="card-add-title">{product.name}</h5>
                <span className="card-add-category">{product.category}</span>
              </div>
              <span className="card-add-price">{price} &#8381;</span>
            </div>
            {product.addition !== "1" && product.period && <span className="card-add-period">{product.period}</span>}
            {!done && product.addition === "1" && (
              <input className="card-add-input modal-checkout-input-block__input" placeholder={product.placeholder_addition} onInput={setAdditionHandler} value={addition} />
            )}
            {done && product.addition === "1" && <span className="card-add-period">{addition}</span>}
          </div>
        </div>
        {!isFetching ? (
          !done ? (
            <ImagesCarousel imagesUrl={product.description_image} />
          ) : null
        ) : (
          <Flex justify="center" align="center" style={{ width: "100%", aspectRatio: "3/2" }}>
            <Spin size="large" description="Загрузка..." />
          </Flex>
        )}
      </div>
      {done && (
        <>
          <button type="button" className="modal-btn" onClick={openCart}>
            Перейти к оформлению заказа
          </button>
          <button type="button" className="modal-btn-clear" onClick={props.closeHandler}>
            Продолжить покупки
          </button>
        </>
      )}
      {!done && (
        <button type="button" className="modal-btn" onClick={addToCart}>
          Добавить товар в корзину
        </button>
      )}
    </div>
  );
};

export default AddToCart;

const ImagesCarousel = memo(({ imagesUrl = "" }) => {
  const images = imagesUrl
    .split(",")
    .map((url) => url.trim())
    .filter((url) => url !== "");

  if (images.length === 0) {
    return <Empty />;
  }

  return (
    <Carousel arrows infinite={false} autoplay={true} style={{ borderRadius: 8, aspectRatio: "3/2", overflow: "hidden" }}>
      {images.map((url, index) => (
        <ImageLoader key={index} src={url} alt={`Product description ${index + 1}`} />
      ))}
    </Carousel>
  );
});

const ImageLoader = ({ src, alt }) => {
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await fetch(api.apiUrl + src);
        const blob = await response.blob();
        const imageObjectURL = URL.createObjectURL(blob);
        setImageSrc(imageObjectURL);
      } catch (error) {
        console.error("Error loading image:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, [src]);

  if (!loading && !imageSrc) {
    return (
      <Flex justify="center" align="center" style={{ width: "100%", aspectRatio: "3/2", backgroundColor: "#f0f0f0" }}>
        <Result status="error" title="Ошибка загрузки изображения" subTitle="Не удалось загрузить изображение. Пожалуйста, попробуйте позже." />
      </Flex>
    );
  }
  if (loading) {
    return <Skeleton.Image active={true} width={"100%"} styles={{ root: { aspectRatio: "3/2", width: "100%" } }} />;
  }

  return (
    <div style={{ width: "100%", aspectRatio: "3/2", position: "relative" }}>
      <div
        style={{
          aspectRatio: "3/2",
          background: `url(${imageSrc}) no-repeat center center/cover`,
          filter: "blur(10px)",
          zIndex: 0,
          position: "absolute",
          top: -10,
          left: -10,
          right: -10,
          bottom: -10,
        }}
      />
      <Image width={"100%"} height={"auto"} src={imageSrc} preview={true} style={{ aspectRatio: "3/2", position: "relative", zIndex: 1 }} />
    </div>
  );
};
